import { searchNav } from '/app/app/assets/js/mixins/search_nav.js'

export default ({ frameId, url, param = 'q', minLength = 2 } = {}) => ({
  ...searchNav({ frameId }),

  onSearch(query) {
    const frame = document.getElementById(frameId)
    if (!frame) return

    const trimmed = (query || '').trim()
    const next = new URL(url, location.origin)
    if (trimmed.length >= minLength) next.searchParams.set(param, trimmed)
    frame.src = next.toString()
  },
})
